import { NATIONAL_SECTION_LEGACY_ID } from "@/pages/people/membership-services/committees/constants";

/**
 * Mirrors `CRM::CommitteePolicy#manage?` for section committees: `manageCommittees` or JWT `manage_section?`.
 * Exception: the National Section (`PGA`) requires `manageCommittees` — backend ignores JWT
 * `manage_section?` for national committees. Person-profile section governance uses
 * `canManageSectionGovernance` instead (backend still allows JWT assignment there, including `PGA`).
 * See pgahq/pga-backend `app/policies/crm/committee_policy.rb`.
 */
export function canManageSectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  sectionLegacyId,
  hasManageCommitteesCapability
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  sectionLegacyId?: string | null;
  hasManageCommitteesCapability: boolean;
}): boolean {
  if (isGlobalAdmin) return true;
  if (!sectionLegacyId) return false;
  if (hasManageCommitteesCapability) return true;
  if (sectionLegacyId === NATIONAL_SECTION_LEGACY_ID) return false;
  return assignedSectionLegacyIds.includes(sectionLegacyId);
}

export function canManageAnySectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  hasManageCommitteesCapability
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  hasManageCommitteesCapability: boolean;
}): boolean {
  return isGlobalAdmin || hasManageCommitteesCapability || assignedSectionLegacyIds.length > 0;
}
